/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 13:11:55
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/ProductDisplayInRowLong1/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
const ProductDisplayInRowLong = (props) => {
  const { img, sku, name, type, remarks, onDelete } = props;
  return (
    <div className={css.container}>
      <img
        height={48}
        width={48}
        src={img}
        style={{ marginRight: 16, marginLeft: 8 }}
      />
      <div className={css.skuContainer}>
        <NoWrapContainer>
          <GlobalTooltip title={sku}>{sku}</GlobalTooltip>
        </NoWrapContainer>
      </div>
      <div className={css.nameContainer}>
        {' '}
        <NoWrapContainer>
          {' '}
          <GlobalTooltip title={name}>{name}</GlobalTooltip>
        </NoWrapContainer>
      </div>
      <div className={css.typeContainer}>
        <NoWrapContainer>
          {' '}
          <GlobalTooltip title={type}>{type}</GlobalTooltip>
        </NoWrapContainer>
      </div>
      <div className={css.remarksContainer}>
        <NoWrapContainer>
          {' '}
          <GlobalTooltip title={remarks}>{remarks}</GlobalTooltip>
        </NoWrapContainer>
      </div>
      {onDelete && (
        <div className={css.iconContainer} onClick={onDelete}>
          <Icon type='icondelete1' className={css.icon} />
        </div>
      )}
    </div>
  );
};
export default ProductDisplayInRowLong;
